<template>
    <button @click="emit('onSubmitBtn')" class="btn login-theme-color  text-white" type="button">{{  submitBtnText }}</button>
</template>

<script setup>
import { defineEmits, defineProps, toRefs } from 'vue'
const emit = defineEmits(['onSubmitBtn'])
const props = defineProps({
    submitBtnText: {
        type: String, required: false, default: () => 'Submit'
    }
})

toRefs(props);
</script>
<style lang="css" scoped>

.login-theme-color {
    background: #48C2F9;
}

.gradient-custom-2:hover {
    opacity: .5;
}

@media (min-width: 768px) {
.gradient-form {
        height: 100vh !important;
    }
}
@media (min-width: 769px) {
    .gradient-custom-2 {
        border-top-right-radius: .3rem;
        border-bottom-right-radius: .3rem;
    }
}
</style>